import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { companiesAPI } from '../services/api'
import type { Company } from '../types'

export default function AdminGlobal() {
  const { t } = useTranslation()
  const [companies, setCompanies] = useState<Company[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    companiesAPI.list()
      .then((resp) => setCompanies(resp.data.companies || []))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <div className="page-header">
        <h1><i className="bi bi-shield-lock me-2"></i>{t('admin.title')}</h1>
      </div>

      <div className="card">
        <div className="card-header">Empresas registradas</div>
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status" />
            </div>
          ) : companies.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <i className="bi bi-building display-4 d-block mb-2"></i>
              <p>No hay empresas sincronizadas. Conecta con el IDP para sincronizar.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>Slug</th>
                    <th>Idioma</th>
                    <th>Estado</th>
                    <th>Creado</th>
                  </tr>
                </thead>
                <tbody>
                  {companies.map((c) => (
                    <tr key={c.id}>
                      <td className="fw-semibold">{c.id}</td>
                      <td>{c.name}</td>
                      <td><code>{c.slug}</code></td>
                      <td>{c.default_language?.toUpperCase()}</td>
                      <td>
                        <span className={`badge bg-${c.is_active ? 'success' : 'secondary'}`}>
                          {c.is_active ? 'Activa' : 'Inactiva'}
                        </span>
                      </td>
                      <td className="text-muted small">
                        {c.created_at ? new Date(c.created_at).toLocaleDateString() : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <div className="card mt-3">
        <div className="card-header">Información del sistema</div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <div className="text-muted small">App Code</div>
              <div className="fw-semibold">contract</div>
            </div>
            <div className="col-md-4">
              <div className="text-muted small">API Version</div>
              <div className="fw-semibold">1.0.0</div>
            </div>
            <div className="col-md-4">
              <div className="text-muted small">Entorno</div>
              <div className="fw-semibold">
                <span className="badge bg-info">{import.meta.env.MODE || 'development'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
